import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-modern">

      {/* <div className="aboutus-floating-decor leaf"></div> */}

      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>About <span>Muktinath Darshan</span></h1>

          <p>
            We specialize in organizing sacred Muktinath Darshan Yatra with
            comfort, safety, and spiritual fulfillment. Our mission is to help
            pilgrims experience divine blessings while enjoying hassle-free
            travel across Nepal.
          </p>
        </div>

        <div className="about-hero-image">
          <img src="/Images/tour/Muktinath-Temple.png" alt="Muktinath Temple" />
          <div className="about-image-overlay"></div>
        </div>
      </div>

      {/* Shape Gallery Section */}
      <div className="about-gallery">
        <div className="shape shape-angled-reverse">
          <img src="/Images/tour/muktinath-darshan-yatra.jpeg" alt="Muktinath Yatra" />
        </div>

        <div className="shape shape-blob">
          <img src="/Images/tour/mount-ama-dablam.jpg" alt="Nepal Mountains" />
        </div>

        <div className="shape shape-angled">
          <img src="/Images/tour/pokhara.jpg" alt="Pokhara Nepal" />
        </div>
      </div>

      {/* About Text Section */}
      <div className="about-text">
        <h2>Who We Are</h2>

        <p>
          <b>Muktinath Darshan</b> is a trusted pilgrimage tour operator
          dedicated to providing spiritually enriching journeys to one of the
          holiest temples of Lord Vishnu located in the Himalayas of Nepal.
        </p>

        <p>
          From transportation and accommodation to permits and guided darshan,
          we manage every detail of your journey. Whether you travel by road or
          helicopter, our experienced team ensures a smooth, safe, and memorable
          pilgrimage experience.
        </p>

        <p>
          Thousands of devotees trust us every year for comfortable,
          well-planned, and budget-friendly Muktinath Yatra packages.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;